/**
 * Formats a date using the given locale, or device locale when not provided.
 * Use user.locale from profile when available so format is consistent across devices.
 */
export const formatDateShort = (date: Date | string, locale?: string): string => {
  const d = new Date(date)
  return locale ? d.toLocaleDateString(locale) : d.toLocaleDateString()
}

/** Returns yyyy-mm-dd for <input type='date'>. Display format is controlled by the browser. */
export const toDateInputValue = (date: Date | string): string => {
  const d = new Date(date)
  return isNaN(d.getTime()) ? '' : d.toISOString().slice(0, 10)
}
